import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { Menu } from 'semantic-ui-react';

import cx from 'classnames';
import { BodyClass, getBaseUrl, hasApiExpander } from '@plone/volto/helpers';
import config from '@plone/volto/registry';
import { getNavigation } from '@plone/volto/actions';
import { CSSTransition } from 'react-transition-group';
import NavItems from '@plone/volto/components/theme/Navigation/NavItems';
import { map } from 'lodash';

const messages = defineMessages({
  closeMobileMenu: {
    id: 'Close menu',
    defaultMessage: 'Close menu',
  },
  openMobileMenu: {
    id: 'Open menu',
    defaultMessage: 'Open menu',
  },
});

const Navigation = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { pathname, type } = props;
  const [isMobileMenuOpen, setisMobileMenuOpen] = useState(false);
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const items = useSelector((state) => state.navigation.items, shallowEqual);
  const lang = useSelector((state) => state.intl.locale);
  const { topActions = [] } = useSelector(
    (state) => ({
      topActions: state.actions?.actions?.top_actions,
    }),
    shallowEqual,
  );

  useEffect(() => {
    const { settings } = config;
    if (!hasApiExpander('navigation', getBaseUrl(pathname))) {
      dispatch(getNavigation(getBaseUrl(pathname), settings.navDepth));
    }
  }, [pathname, token, dispatch]);

  const toggleMobileMenu = () => {
    setisMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    if (!isMobileMenuOpen) {
      return;
    }
    setisMobileMenuOpen(false);
  };

  return (
    <nav className="navigation mnPrincipal" id="navigation" aria-label="Site">
      <div className="hamburger-wrapper mobile tablet only">
        <button
          className={cx('hamburger hamburger--spin', {
            'is-active': isMobileMenuOpen,
          })}          
          type="button"
          onClick={toggleMobileMenu}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
          <span className="visually-hidden">{
            isMobileMenuOpen
              ? intl.formatMessage(messages.closeMobileMenu, {
                  type: type,
                })
              : intl.formatMessage(messages.openMobileMenu, {
                  type: type,
                })
            }</span>
        </button>
      </div>
      <Menu
        stackable
        pointing
        secondary
        className="computer large screen widescreen only desktop-menu-nav"
        onClick={closeMobileMenu}
      >
        
        <NavItems items={items} lang={lang} mobile={false} />
      </Menu>
      <CSSTransition
        in={isMobileMenuOpen}
        timeout={500}
        classNames="mobile-menu"
        unmountOnExit
      >
        <div key="mobile-menu-key" className="mobile-menu">
          <BodyClass className="has-mobile-menu-open" />
          <div className="mobile-menu-nav">
            <div>
              <Menu stackable pointing secondary onClick={closeMobileMenu}>
                <NavItems items={items} lang={lang} mobile={true} />
              </Menu>
              <ul className="topActionsMobile ">
                {topActions?.length
                  ? map(topActions, (item, index) => (
                    <li className={index ? 'ms-3 ps-3 border-start': null} key={item.id}>
                      <a className="text-decoration-none" target="_blank" rel="noopener" href={item.url}>
                        {item?.title}
                      </a>
                    </li>
                  ))
                : <li></li>}
              </ul>
            </div>
          </div>
        </div>
      </CSSTransition>
    </nav>
  );
};

Navigation.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default Navigation;
